import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Mensaje`

export function buscarPorPedidoItem(idPedidoItem, idComprador) {
  return http.get(`${API_ENDPOINT}/BuscarPorPedidoItem/${idPedidoItem}/${idComprador}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los mensajes.',
      tipoError: 'mensajeria'
    }
  })
}

export function buscarEnPublicaciones(idComprador, search) {
  return http.get(`${API_ENDPOINT}/BuscarEnPublicaciones/${idComprador}/${search}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los mensajes.',
      tipoError: 'mensajeria'
    }
  })
}

export function buscarEnPublicacionPorComprador(idPublicacion, idComprador) {
  return http.get(
    `${API_ENDPOINT}/BuscarEnPublicacionPorComprador/${idPublicacion}/${idComprador}`,
    {
      meta: {
        toastMessage: 'Ocurrió un error al obtener los mensajes.',
        tipoError: 'mensajeria'
      }
    }
  )
}

export function buscarPorPublicacion(idPublicacion) {
  return http.get(`${API_ENDPOINT}/BuscarPorPublicacion/${idPublicacion}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los mensajes.',
      tipoError: 'mensajeria'
    }
  })
}

export function buscarPorPresupuesto(idPresupuesto) {
  return http.get(`${API_ENDPOINT}/BuscarPorPresupuesto/${idPresupuesto}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los mensajes.',
      tipoError: 'mensajeria'
    }
  })
}

export function buscarPorPedido(idPedido, idComprador) {
  return http.get(`${API_ENDPOINT}/BuscarPorPedido/${idPedido}/${idComprador}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los mensajes.',
      tipoError: 'mensajeria'
    }
  })
}

export function actualizar(mensaje) {
  return http.put(API_ENDPOINT, mensaje)
}

export function insertar(mensaje) {
  return http.post(API_ENDPOINT, mensaje)
}

export function eliminar(idMensaje) {
  return http.delete(`${API_ENDPOINT}/${idMensaje}`)
}
